export interface TradeMenuLink {
  href: string;
  label: string;
  blurb?: string;
}

export const TRADE_PROGRAMMES: TradeMenuLink[] = [
  { href: "/commercial", label: "Commercial Overview" },
  { href: "/commercial-retrofit", label: "Whole-House Retrofit" },
  { href: "/commercial-damp-mould-ventilation", label: "Damp, Mould & Ventilation" },
  { href: "/commercial-insulation", label: "Insulation Programmes" },
  { href: "/commercial-heat-pumps", label: "Heat Pump Programmes" },
  { href: "/commercial-solar-pv", label: "Commercial Solar PV" },
  { href: "/commercial-heating", label: "Gas, Boiler & Heating" },
  { href: "/commercial-structural", label: "Structural & Remedial" },
];

export const TRADE_RESOURCES: TradeMenuLink[] = [
  {
    href: "/commercial-compliance",
    label: "Compliance & Accreditations",
    blurb:
      "Held accreditations and insurances with status and renewal dates.",
  },
  {
    href: "/commercial-social-value",
    label: "Social Value Reporting",
    blurb:
      "Local jobs, apprenticeships, supply chain and community benefit, agreed up front and reported on completion.",
  },
  {
    href: "/commercial-case-studies",
    label: "Case Studies",
    blurb:
      "Commercial and framework projects with scope, risks managed and outcomes.",
  },
];
